import { DEFAULT_PAGE_SIZE } from "commons/constants";
import { AutoCompleteMode } from "../models/control";
import { AutoCompleteMetaDataLike, AutoCompleteRenderMode } from "./types";

export const resolveAutoCompleteRenderMode = (
  metaData: AutoCompleteMetaDataLike,
): AutoCompleteRenderMode => {
  const mode: AutoCompleteMode = metaData?.autoCompleteMode ?? "auto";
  const hasPagedSearchFunc =
    typeof metaData?.searchOptionItemsPagedAsync === "function";

  if (mode === "legacy") return "legacy";
  if (mode === "paged") {
    return hasPagedSearchFunc ? "paged" : "legacy";
  }

  return hasPagedSearchFunc ? "paged" : "legacy";
};

export const resolveAutoCompletePageSize = (pageSize?: number): number => {
  if (typeof pageSize === "number" && pageSize > 0) {
    return pageSize;
  }

  return DEFAULT_PAGE_SIZE;
};
